import { LocalStorage } from "../models/LocalStorage";
import { MINI_APP } from "./miniApp";

export class GA {
  static logEvent({
    name,
    parameters,
  } = {}) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logEventGA({
        name: name,
        parameters: parameters,
      })
    } else {
      return window.gtag("event", name, parameters);
    }
  }

  static logViewItem({
    items,
    value,
    currency,
    source,
    parameters,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logViewItemGA({
        items: items,
        value: value,
        currency: currency,
        source: source,
        parameters: parameters,
      })
    } else {
      return window.gtag("event", 'view_item', {
        items: items,
        value: value,
        currency: currency,
        source: source,
        ...(parameters ?? {}),
      });
    }
  }

  static logAddToCart({
    items,
    value,
    currency,
    orderCode,
    source,
    parameters,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logAddToCartGA({
        items: items,
        value: value,
        currency: currency,
        order_code: orderCode,
        source: source,
        parameters: parameters,
      })
    } else {
      return window.gtag("event", 'add_to_cart', {
        items: items,
        value: value,
        currency: currency,
        order_code: orderCode,
        source: source,
        ...(parameters ?? {}),
      });
    }
  }

  static logBeginCheckout({
    items,
    value,
    currency,
    coupon,
    orderCode,
    parameters,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logBeginCheckoutGA({
        items: items,
        value: value,
        currency: currency,
        coupon: coupon,
        order_code: orderCode,
        parameters: parameters,
      })
    } else {
      return window.gtag("event", 'begin_checkout', {
        items: items,
        value: value,
        currency: currency,
        coupon: coupon,
        order_code: orderCode,
        ...(parameters ?? {}),
      });
    }
  }

  static logPurchase({
    items,
    value,
    currency,
    coupon,
    tax,
    shipping,
    transactionId,
    affiliation,
    orderCode,
    parameters,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logPurchaseGA({
        items: items,
        value: value,
        currency: currency,
        coupon: coupon,
        tax: tax,
        shipping: shipping,
        transactionId: transactionId,
        affiliation: affiliation,
        orderCode: orderCode,
        parameters: parameters,
      })
    } else {
      return window.gtag("event", 'purchase', {
        items: items,
        value: value,
        currency: currency,
        coupon: coupon,
        tax: tax,
        shipping: shipping,
        transactionId: transactionId,
        affiliation: affiliation,
        orderCode: orderCode,
        ...(parameters ?? {}),
      });
    }
  }
}

export class FA {
  static logEvent({
    name,
    parameters,
    valueToSum,
  } = {}) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logEventFA({
        name: name,
        parameters: parameters,
        valueToSum: valueToSum,
      })
    }
  }

  static logViewItem({
    items,
    value,
    currency,
    source,
    parameters,
    type,
    sku,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logViewItemFA({
        type: type,
        sku: sku,
        items: items,
        value: value,
        currency: currency,
        source: source,
        parameters: parameters,
      })
    }
  }

  static logAddToCart({
    items,
    value,
    currency,
    orderCode,
    source,
    parameters,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logAddToCartFA({
        items: items,
        value: value,
        currency: currency,
        order_code: orderCode,
        source: source,
        parameters: parameters,
      })
    }
  }

  static logBeginCheckout({
    items,
    value,
    currency,
    coupon,
    orderCode,
    parameters,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logBeginCheckoutFA({
        items: items,
        value: value,
        currency: currency,
        coupon: coupon,
        order_code: orderCode,
        parameters: parameters,
      })
    }
  }

  static logPurchase({
    items,
    value,
    currency,
    coupon,
    orderCode,
    parameters,
  }) {
    if (LocalStorage.isMiniApp()) {
      return MINI_APP.logPurchaseFA({
        items: items,
        value: value,
        currency: currency,
        coupon: coupon,
        orderCode: orderCode,
        parameters: parameters,
      })
    }
  }
}